import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=dd2b0c7a&scoped=true&"
import script from "./TemplateEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=dd2b0c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2b0c7a",
  null
  
)

export default component.exports